import React from 'react';
import ReferralCard from '../components/ReferralCard';
import ShareWin from '../components/ShareWin';

/*
 * Refer — the growth-loop page. Gives a user their referral link, explains the
 * "invite friends, unlock more" loop, and lets them share a win on social.
 */
function Refer() {
  return (
    <div className="mx-auto max-w-2xl px-4 py-10 sm:px-6">
      <h1 className="text-2xl font-bold tracking-tight text-gray-900">
        Invite friends, unlock more
      </h1>
      <p className="mt-2 text-sm text-gray-500">
        Share your link with candidates and recruiters. Every signup grows the
        AutoHire network — better matches, faster intros, and more reach for you.
      </p>

      <div className="mt-8 space-y-6">
        <ReferralCard />
        <ShareWin />
      </div>
    </div>
  );
}

export default Refer;
